import { Component, OnInit, ViewChild } from '@angular/core';
import 'anychart';
import { Subject, Subscription } from 'rxjs';
import { PersonasService } from '../../providers/personas.service';
import { PropuestasService } from '../../providers/propuestas.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DashboardService } from '../../providers/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})



export class DashboardComponent implements OnInit {

  cargando: boolean[] = [];
  subscription: Subscription;
  datoschart: any;
  cantidadCircle = 0;
  cantidadHorizontal = 0;
  date1 = new Date();
  latest_date = this._datepipe.transform(this.date1, 'yyyy-MM-dd');
  form = this._formBuilder.group({
    fecha_desde: [this.latest_date],
    fecha_hasta: [this.latest_date]
  })

  @ViewChild('container') container?;
  @ViewChild('chartBar') chartBar;
  @ViewChild('circleChart') circleChart;
  @ViewChild('speedBar') speedBar;
  chartFunnel: anychart.charts.Funnel = null;
  chartHorizontal = null;
  chartCircle = null;
  chartLine = null;
  datoFunnel: any[];
  datosCircle: any[];
  datosHorizontal: any[];
  estadisticaBarSituacion: any[];
  cantidadFunnel = 0;
  cantidadPropuestasNuevas: any;
  valor_estimado: any;
  constructor(
    private _propuestaService: PropuestasService,
    private _personasSv: PersonasService,
    private _formBuilder: FormBuilder,
    private _datepipe: DatePipe,
    private _dashboardSv: DashboardService,
  ) {
    this._dashboardSv.dataSetChanged$.subscribe(
      (resp: any) => {
        switch (resp.chart) {
          case 'Funnel':
            this.chartFunnel.data(resp.datos)
            this.cantidadFunnel = resp.total;
            break;
          case 'Circle':
            this.chartCircle.data(resp.datos)
            this.cantidadCircle = resp.total;
            break;
          case 'Horizontal':
            this.chartHorizontal.data(resp.datos);
            this.cantidadHorizontal = resp.total;
            break;
        }
      }
    );

  }

  ngOnInit() {
    this.chartFunnel = anychart.funnel(this._dashboardSv.getDataInicializador());
    this.chartCircle = anychart.pie(this._dashboardSv.getDataInicializador());
    this.chartHorizontal = anychart.bar(this._dashboardSv.getDataInicializador());
    this.inicializarTodo();
  }
  inicializarTodo() {
    this.EstadisticaBarSituacion();
    this.EstadisticasValores();
  }
  submit() {
    this._dashboardSv.setCurrentDataSet(this.form.getRawValue());
    this.EstadisticaBarSituacion();
    this.EstadisticasValores();
  }
  valor_total: any;
  EstadisticasValores() {
    this._propuestaService.estadisticasPropuestas(
      this.form.getRawValue()
    ).subscribe(
      respuesta => {
        // console.log(respuesta, "valores")
        this.cantidadPropuestasNuevas = respuesta.nuevas_propuestas;
        this.valor_estimado = respuesta.valor_estimado;
        this.valor_total = respuesta.valor_total;
      },
      () => {
        this.cargando.pop();
      },
      () => {
        this.cargando.pop();
      }

    )
  }
  EstadisticaBarSituacion(): void {
    this.cargando.push(true)
    this._propuestaService.estadisticaSituacionPropuestas(
      this.form.getRawValue()
    ).subscribe(
      respuesta => {
        // console.log(respuesta, "Estadisticas bar situacion")
        this.estadisticaBarSituacion = Object.keys(respuesta).map(function (key) {
          return respuesta[key];
        });
        this.cargando.pop();
      }
    );

  }
  ngAfterViewInit() {
    //Funnel
    this.chartFunnel.container(this.container.nativeElement);
    this.chartFunnel.background('transparent');
    this.chartFunnel.neckWidth("20%");
    this.chartFunnel.neckHeight("35%");
    this.chartFunnel.tooltip().format("Propuestas : {%value}");
    this.chartFunnel.draw();

    //Circle
    this.chartCircle.labels().hAlign('center').position('outside')
    this.chartCircle.radius('43%').innerRadius('50%');
    this.chartCircle.container(this.circleChart.nativeElement);
    this.chartCircle.background('transparent');
    this.chartCircle.tooltip().format("Actividades: {%value}");
    this.chartCircle.draw();

    //Horizontal bar
    this.chartHorizontal.container(this.chartBar.nativeElement);
    this.chartHorizontal.background('transparent');
    this.chartHorizontal.draw();
  }
}
